var map = {
	"./in_(1).gif": "84b4",
	"./in_(2).gif": "02ea",
	"./in_(3).gif": "f688",
	"./in_(4).gif": "2a1e",
	"./in_(5).gif": "ed0b",
	"./in_(6).gif": "8421"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cb2";